import { render, staticRenderFns } from "./AddFair.vue?vue&type=template&id=01c5864c&scoped=true&"
import script from "./AddFair.vue?vue&type=script&lang=js&"
export * from "./AddFair.vue?vue&type=script&lang=js&"
import style0 from "./AddFair.vue?vue&type=style&index=0&id=01c5864c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c5864c",
  null
  
)

export default component.exports